define(["require", "exports", "./ServiceBase"], function (require, exports, ServiceBase_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FacilityService = void 0;
    class FacilityService extends ServiceBase_1.ServiceBase {
        constructor(httpProtocol, hostName, serviceName, proxyUrl) {
            super("Facility", httpProtocol, hostName, serviceName, proxyUrl);
        }
        syncWpProgressReports() {
            let p = {};
            return this.post("SyncWpProgressReports", p, (json) => {
                return json;
            });
        }
        sendWpProgressReportReminders() {
            let p = {};
            return this.post("SendWpProgressReportReminders", p, (json) => {
                return json;
            });
        }
        createWpProgressReport(wp, dueDate) {
            let p = {};
            p.wp = wp;
            p.dueDate = dueDate.valueOf();
            return this.post("CreateWpProgressReport", p, (json) => {
                return json;
            });
        }
        createFacility(geometry) {
            let p = {};
            p.geometry = geometry.toJSON();
            return this.post("CreateFacility", p, (json) => {
                return json;
            });
        }
        createFacilityAsset(facilityId, geometry) {
            let p = {};
            p.facilityId = facilityId;
            p.geometry = geometry.toJSON();
            return this.post("CreateFacilityAsset", p, (json) => {
                return json;
            });
        }
        createFacilityInspection(facility) {
            let p = {};
            p.facility = facility;
            return this.post("CreateFacilityInspection", p, (json) => {
                return json;
            });
        }
        createFacilityInspectionAsset(inspId, geometry) {
            let p = {};
            p.inspId = inspId;
            p.geometry = geometry.toJSON();
            return this.post("CreateFacilityInspectionAsset", p, (json) => {
                return json;
            });
        }
        createFacilityInspectionAmendment(facility, inspId) {
            let p = {};
            p.facility = facility;
            p.inspId = inspId;
            return this.post("CreateFacilityInspectionAmendment", p, (json) => {
                return json;
            });
        }
        createFacilityWorks(facility) {
            let p = {};
            p.facility = facility;
            return this.post("CreateFacilityWorks", p, (json) => {
                return json;
            });
        }
        createNewFacilityAsset(wpId, assetType) {
            let p = {};
            p.wpId = wpId;
            p.assetType = assetType;
            return this.post("CreateNewFacilityAsset", p, (json) => {
                return json;
            });
        }
        enhanceFacilityAsset(wpId, facilityAsset) {
            let p = {};
            p.wpId = wpId;
            p.facilityAsset = facilityAsset;
            return this.post("EnhanceFacilityAsset", p, (json) => {
                return json;
            });
        }
        findFacility(queryCriteria, includeSummaryFieldsOnly) {
            let p = {};
            p.queryCriteria = queryCriteria;
            p.includeSummaryFieldsOnly = includeSummaryFieldsOnly;
            return this.post("FindFacility", p, (json) => {
                return json;
            });
        }
        generateAggregatedFacilityReport(reportParameters) {
            let p = {};
            p.reportParameters = reportParameters;
            return this.post("GenerateAggregatedFacilityReport", p, (json) => {
                return json;
            });
        }
        generateFacilityWorksProjectDocument(project, documentType) {
            let p = {};
            p.project = project;
            p.documentType = documentType;
            return this.post("GenerateFacilityWorksProjectDocument", p, (json) => {
                return json;
            });
        }
        getAggregatedFacilityReport(reportFileId) {
            let p = {};
            p.reportFileId = reportFileId;
            return this.requestFile("GetAggregatedFacilityReport", p);
        }
        getFacilityAssetChangeHistory(assetId) {
            let p = {};
            p.assetId = assetId;
            return this.post("GetFacilityAssetChangeHistory", p, (json) => {
                return json;
            });
        }
        getFacilityDocument(documentId) {
            let p = {};
            p.documentId = documentId;
            return this.requestFile("GetFacilityDocument", p);
        }
        getFacilityWorksProjectDocument(documentId) {
            let p = {};
            p.documentId = documentId;
            return this.requestFile("GetFacilityWorksProjectDocument", p);
        }
        getFacilityInspectionDocument(documentId) {
            let p = {};
            p.documentId = documentId;
            return this.requestFile("GetFacilityInspectionDocument", p);
        }
        getFacilityLgaOnGeometryChange(geometry) {
            let p = {};
            p.geometry = geometry.toJSON();
            return this.post("GetFacilityLgaOnGeometryChange", p, (json) => {
                return json;
            });
        }
        getFacilityReferenceData() {
            let p = {};
            return this.post("GetFacilityReferenceData", p, (json) => {
                return json;
            });
        }
        getFacilityWaterAgreementHistory(facilityId) {
            let p = {};
            p.facilityId = facilityId;
            return this.post("GetFacilityWaterAgreementHistory", p, (json) => {
                return json;
            });
        }
        getStocktakePeriodInspectionsByLga(fiscalYear, lgaCode) {
            let p = {};
            p.fiscalYear = fiscalYear;
            p.lgaCode = lgaCode;
            return this.post("GetStocktakePeriodInspectionsByLga", p, (json) => {
                return json;
            });
        }
        getStocktakePeriodLgas(fiscalYear) {
            let p = {};
            p.fiscalYear = fiscalYear;
            return this.post("GetStocktakePeriodLgas", p, (json) => {
                return json;
            });
        }
        persistFacility(facility) {
            let p = {};
            p.facility = facility;
            return this.post("PersistFacility", p, (json) => {
                return json;
            });
        }
        readFacility(id) {
            let p = {};
            p.id = id;
            return this.post("ReadFacility", p, (json) => {
                return json;
            });
        }
        readFacilityByInspection(inspectionId) {
            let p = {};
            p.inspectionId = inspectionId;
            return this.post("ReadFacilityByInspection", p, (json) => {
                return json;
            });
        }
        readFacilityByWorksProject(wpId) {
            let p = {};
            p.wpId = wpId;
            return this.post("ReadFacilityByWorksProject", p, (json) => {
                return json;
            });
        }
        readFacilityDocuments(facilityId) {
            let p = {};
            p.facilityId = facilityId;
            return this.post("ReadFacilityDocuments", p, (json) => {
                return json;
            });
        }
        readFacilityDocumentsByInspection(inspId) {
            let p = {};
            p.inspId = inspId;
            return this.post("ReadFacilityDocumentsByInspection", p, (json) => {
                return json;
            });
        }
        readFacilityDocumentsByWp(wpId) {
            let p = {};
            p.wpId = wpId;
            return this.post("ReadFacilityDocumentsByWp", p, (json) => {
                return json;
            });
        }
        readFacilityInspection(inspectionId, loadChildren) {
            let p = {};
            p.inspectionId = inspectionId;
            p.loadChildren = loadChildren;
            return this.post("ReadFacilityInspection", p, (json) => {
                return json;
            });
        }
        readFacilityWorksProject(wpId, loadChildren) {
            let p = {};
            p.wpId = wpId;
            p.loadChildren = loadChildren;
            return this.post("ReadFacilityWorksProject", p, (json) => {
                return json;
            });
        }
        replaceExistingFacilityAsset(wpAssetId, assetToReplaceId, removeAsset) {
            let p = {};
            p.wpAssetId = wpAssetId;
            p.assetToReplaceId = assetToReplaceId;
            p.removeAsset = removeAsset;
            return this.post("ReplaceExistingFacilityAsset", p, (json) => {
                return json;
            });
        }
        updateFacilityDataFromSap(documentName, base64Document) {
            let p = {};
            p.documentName = documentName;
            p.base64Document = base64Document;
            return this.post("UpdateFacilityDataFromSap", p, (json) => {
                return json;
            });
        }
        updateFacilityOnGeometryChange(facility) {
            let p = {};
            p.facility = facility;
            return this.post("UpdateFacilityOnGeometryChange", p, (json) => {
                return json;
            });
        }
        updateStocktakePeriod(changes) {
            let p = {};
            p.changes = changes;
            return this.post("UpdateStocktakePeriod", p, (json) => {
                return json;
            });
        }
        uploadFacilityDocument(facilityId, documentType, documentName, base64Document) {
            let p = {};
            p.facilityId = facilityId;
            p.documentType = documentType;
            p.documentName = documentName;
            p.base64Document = base64Document;
            return this.post("UploadFacilityDocument", p, (json) => {
                return json;
            });
        }
        uploadFacilityInspectionDocument(inspId, documentType, documentName, base64Document) {
            let p = {};
            p.inspId = inspId;
            p.documentType = documentType;
            p.documentName = documentName;
            p.base64Document = base64Document;
            return this.post("UploadFacilityInspectionDocument", p, (json) => {
                return json;
            });
        }
        uploadFacilityWorksProjectDocument(wpId, documentType, documentName, base64Document) {
            let p = {};
            p.wpId = wpId;
            p.documentType = documentType;
            p.documentName = documentName;
            p.base64Document = base64Document;
            return this.post("UploadFacilityWorksProjectDocument", p, (json) => {
                return json;
            });
        }
        validateFacility(facility) {
            let p = {};
            p.facility = facility;
            return this.post("ValidateFacility", p, (json) => {
                return json;
            });
        }
        getAuthorisedLgas() {
            let p = {};
            return this.post("GetAuthorisedLgas", p, (json) => {
                return json;
            });
        }
        getAuthorisedLgasWithGeometry(returnPolyline, generalise) {
            let p = {};
            p.returnPolyline = returnPolyline;
            p.generalise = generalise;
            return this.post("GetAuthorisedLgasWithGeometry", p, (json) => {
                return json;
            });
        }
        getConfiguration() {
            let p = {};
            return this.post("GetConfiguration", p, (json) => {
                return json;
            });
        }
        getLgas() {
            let p = {};
            return this.post("GetLgas", p, (json) => {
                return json;
            });
        }
        getLotPlanQvasEvaluation(lotPlan) {
            let p = {};
            p.lotPlan = lotPlan;
            return this.post("GetLotPlanQvasEvaluation", p, (json) => {
                return json;
            });
        }
        getUser() {
            let p = {};
            return this.post("GetUser", p, (json) => {
                return json;
            });
        }
        keepAlive() {
            let p = {};
            return this.post("KeepAlive", p, (json) => {
                return json;
            });
        }
    }
    exports.FacilityService = FacilityService;
});
